/**
 * 背景(親要素)のスクロールを阻止するためのスタイルを追加
 * positionは一部ios用
 * widthは表示崩れ防止（経緯：https://furyu-gtb.slack.com/archives/C010J38KC2Z/p1647579594372839）
 */
export function setNotScrollBackground() {
    document.querySelector('body').style.overflow = 'hidden';
    document.querySelector('body').style.position = 'fixed';
    document.querySelector('body').style.width = '100%';
}
